import React from 'react'
import classnames from 'classnames/bind'

// Styles
import styles from './style.module.scss'

// Components
import Icon from '@/assets/icons'
import Insight from '@/components/shared/Insight'
import Image from '@/components/common/Image'

// Libs
import useSearchHotKeyLive from '@/hooks/useSearchHotKeyLive'

// Constants
import { ImageSizes } from '@/constants/imageSizes'

const cx = classnames.bind(styles)

interface ILinkCard {
  title: string
  image: string
  description?: string
  handleClick?: () => void
}

const LinkCard = (props: ILinkCard) => {
  const { image, title, handleClick } = props
  const { isLive } = useSearchHotKeyLive({ keyword: title })

  return (
    <div
      className={cx('link-card')}
      onClick={() => {
        handleClick && handleClick()
      }}
    >
      <div className={cx('link-card__content')}>
        <div className={cx('link-card__content-image')}>
          <Image src={image} fill alt='link-card-image' sizes={ImageSizes.headShot} style={{ objectFit: 'contain', objectPosition: 'center' }} />
          {isLive && (
            <Insight className={cx('link-card__content-image-insight')} status='empty' theme='gray' position='absolute' bottom='0px' right='0px' />
          )}
        </div>
        <div className={cx('link-card__content-text')}>
          <p className={cx('link-card__content-text-title')}>{title}</p>
        </div>
      </div>
      <div className={cx('link-card__content-icon')}>
        <Icon.ArrowRight />
      </div>
    </div>
  )
}

export default LinkCard
